module.exports = __webpack_public_path__ + "0ca20267577b92f06b80e0e9a6fa9fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/promo/ts_lb_dreamhack.jpg
// module id = 1041
// module chunks = 0